import { EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface MarkerProps {
    boldBefore: string;
    text: string;
    boldAfter: string;
    categories: string;
    standNumber: string;
}

const categoryFES_id = '0e10e9de-6376-4331-836e-932dddbfb60f';
const categoryFCHT_id = 'd7566525-82aa-4241-9fd7-11d4dd04b779';
const categoryFDFJP_id = 'fe864028-280a-4b5b-a2b1-e88e471d9bac';
const categoryFEI_id = '69b2f24c-17e5-4d2b-a9eb-0fb4e62f6f3d';

export const kontakt2024MarkerVariables = [
    {
        variableName: 'boldBefore' as const,
        type: 'string' as const
    },
    {
        variableName: 'text' as const,
        type: 'string' as const
    },
    {
        variableName: 'boldAfter' as const,
        type: 'string' as const
    },
    {
        variableName: 'standNumber' as const,
        type: 'string' as const
    }
];

export const Kontakt2024Marker = (props: MarkerProps) => {
    const categories = props.categories?.split(';') ?? [];

    const isInCategory1 = categories.includes(categoryFES_id);
    const isInCategory2 = categories.includes(categoryFCHT_id);
    const isInCategory3 = categories.includes(categoryFDFJP_id);
    const isInCategory4 = categories.includes(categoryFEI_id);

    const isInAnyCategory = isInCategory1 || isInCategory2 || isInCategory3 || isInCategory4;

    return (
        <S_Container>
            <S_Text>
                <S_Bold>{props.boldBefore}</S_Bold>
                {props.text}
                <S_Bold>{props.boldAfter}</S_Bold>
                <S_StandNumber>{props.standNumber}</S_StandNumber>
            </S_Text>
            {isInAnyCategory && (
                <S_Circle>
                    <S_InnerCircle>
                        {isInCategory1 && <S_Quarter $background={'#97C87F'} $rotate={180} />}
                        {isInCategory2 && <S_Quarter $background={'#EE6A6A'} $rotate={270} />}
                        {isInCategory3 && <S_Quarter $background={'#6AA7EE'} $rotate={0} />}
                        {isInCategory4 && <S_Quarter $background={'#6AE6EE'} $rotate={90} />}

                        <S_Line $rotate={0} />
                        <S_Line $rotate={90} />
                        <S_Line $rotate={180} />
                        <S_Line $rotate={270} />
                    </S_InnerCircle>
                </S_Circle>
            )}
        </S_Container>
    );
};

const S_Container = styled.div`
    width: 120px;
    height: 100px;
    padding: 2px 2px;
    border-radius: 5px;
    border: 1px solid #113042;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #193143;
    background: #ffffff;
    box-shadow: 2px 2px 10px rgb(0 0 0 / 25%), inset 0px -3px 0px #bc0100,
        inset 0px 0px 40px 5px #ffa5a5;
`;

const S_Text = styled.div`
    font-family: ${EFonts.Regular};
    font-size: 14px;
    padding: 0 3px;
    margin: -3px 0 0 0;
`;

const S_Bold = styled.div`
    font-weight: bold;
`;

const S_StandNumber = styled.div`
    position: absolute;
    left: 5px;
    bottom: 5px;
`;

const S_Circle = styled.div`
    background: #ffa5a5;
    width: 36px;
    height: 36px;
    display: block;
    position: absolute;
    bottom: -18px;
    right: -12px;
    border-radius: 50%;
    padding: 1px;
    border: 1px solid #113042;
`;

const S_InnerCircle = styled.div`
    background: #ffffff;
    width: 30px;
    height: 30px;
    display: block;
    margin: 1px 0px 0px 1px;
    border-radius: 50%;
    border: 1px solid #113042;
    overflow: hidden;
    position: relative;
`;

interface SQuarterProps {
    $rotate: number;
    $background: string;
}

const S_Quarter = styled.div.attrs<SQuarterProps>((props) => ({
    style: {
        background: props.$background,
        transform: `rotate(${props.$rotate}deg)`
    }
}))<SQuarterProps>`
    width: 14px;
    height: 14px;
    padding: 1px;
    bottom: 0;
    position: absolute;
    left: 0px;
    top: 0px;
    transform-origin: bottom right;
`;

interface SLineProps {
    $rotate: number;
}

const S_Line = styled.div.attrs<SLineProps>((props) => ({
    style: {
        transform: `rotate(${props.$rotate}deg)`
    }
}))<SLineProps>`
    transform-origin: center;
    left: -2px;
    right: -2px;
    top: 14px;
    position: absolute;
    height: 1px;
    background: #113042;
`;
